import TypeDataDevis from "../types/data-form-devis";

const fetchPostFormDevis = async (formData: TypeDataDevis) => {
  var data: any = ''
  try {
      const response = await fetch(`/wp-json/v1/send-devis`, {
          method: "POST",
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),

      });
      data =   {data : await response.json(), status: response.status};
  } catch(error) {
      return error
  }
  return data
}
export default fetchPostFormDevis;